import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule, LazyAction, type LazyComponent } from 'owa-bundling';
import store from './store/store';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailRibbonCustomizer"*/ './lazyIndex'),
    { name: 'MailRibbonCustomizer' }
);

// Delay loaded components
export const LazyRibbonCustomizer: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.RibbonCustomizer,
    undefined,
    undefined,
    { onlyImportIf: () => store().isCustomizing }
);

export const lazyOnOpenCustomizer: LazyAction<
    typeof lazyIndex.onOpenCustomizer,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onOpenCustomizer);
